var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import { observer } from 'mobx-react';

import Select from 'react-select';

export var EntrySelector = observer(function (props) {
  return React.createElement(Select, _extends({
    className: 'gmcd-select' }, props, { clearable: true,
    menuPortalTarget: document.body
  }));
});